module.exports = __webpack_public_path__ + "c2307c1f7a804a26f4a063dac6dadfc9.png";